import { Component, OnInit } from '@angular/core';
import { getpublicportalfaqsbyid_webportal } from 'src/app/core/models/getpublicportalfaqsbyid_webportal';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FAQsComponent implements OnInit {
  objgetpublicportalfaqsbyid_webportal:getpublicportalfaqsbyid_webportal
  totalPages: any;
  totalRecords: any;
  pages: any[];
  Records: any;
  constructor(public userUtilsService:UserUtilService,public publicPortalService:PublicPortalService) { }

  ngOnInit(): void {
    this.objgetpublicportalfaqsbyid_webportal=new getpublicportalfaqsbyid_webportal()
    this.getpublicportalfaqsbyid_webportal()
  }

  getpublicportalfaqsbyid_webportal(){
    this.objgetpublicportalfaqsbyid_webportal.ID=0
    this.publicPortalService.getpublicportalfaqsbyid_webportal(this.objgetpublicportalfaqsbyid_webportal)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.totalPages = data?.totalPages;
              this.totalRecords = data?.totalRecords;
              this.pages = new Array();
              for (let i = 1; i <= this.totalPages; i++) {
                this.pages.push(i);
              }

              this.Records = data
            }
          }
        }
      })
  }
}
